<div [ngClass]="{ 'flex-grow-1': (state.items$ | async)?.length === 0 }" class="table-wrapper">
  <app-data-grid
    [dateFormatType]="'grid-date-time-sec'"
    [sortOrder]="(model.state.gridSortOrder$ | async) || undefined"
    [isLoading]="(model.state.isPending$ | async) ?? false"
    [isLoadingMore]="(model.state.isLoadingNextPage$ | async) ?? false"
    [data]="(model.state.items$ | async) ?? []"
    [columns]="(model.state.columns$ | async) ?? []"
    [paginationEnabled]="(model.state.canLoadNextPage$ | async) ?? false"
    [templates]="{ name }"
    [rowHover]="true"
    [noDataIconTemplate]="
      model.isSearchOrFilterApplied ? gridEmptySearchIconTmpl : gridEmptyStateIconTmpl
    "
    [noDataTitle]="'search.no-data-title' | translate"
    [noDataDescription]="
      (model.isSearchOrFilterApplied ? 'search.no-data-description' : '') | translate
    "
    (sortUpdated)="model.setOrder($event)"
    (columnItemClicked)="model.select($event)"
    (loadMoreClicked)="model.loadNextPage()"
  ></app-data-grid>
</div>

<ng-template #name let-row="row">
  <div class="flex gap-8 align-items-center">
    <div class="text-14 fw-400 color-gray-900">{{ row.name }}</div>
    @let isCustom =
      row.id >= TYPES.TI_CUSTOM_ROLE_ID_RANGE[0] && row.id <= TYPES.FLEET_CUSTOM_ROLE_ID_RANGE[1];
    @if (isCustom) {
      <p-tag class="p-2-6" [value]="'roles.grid.custom' | translate"> </p-tag>
    }
  </div>
</ng-template>

<ng-template #gridEmptyStateIconTmpl>
  <app-icon-file-search></app-icon-file-search>
</ng-template>

<ng-template #gridEmptySearchIconTmpl>
  <app-icon-no-search></app-icon-no-search>
</ng-template>
